<mat-card
	tabindex="0"
	class="card"
	[class.disabled]="!!activeNavigation()"
	appearance="outlined"
	[attr.aria-busy]="!!activeNavigation()"
	[attr.aria-disabled]="!!activeNavigation()"
	(click)="onCardSelected($event)"
	(keydown.enter)="onCardSelected($event)"
>
	<mat-card-title class="text truncate" [aria-label]="'client.client_card.field.client_card' | transloco">{{
		client().fullName
	}}</mat-card-title>

	@if (client().activeAssignments.length === 0) {
		<section class="assignments-panel" *lvrPermission="['Assignments.Read', 'Clients.Read.PhaseOneOnly']">
			<div class="assignment-block">
				<div class="assignment-info">
					<p class="info-line">
						{{ 'client.client_card.field.no_contact_yet' | transloco }}
					</p>
				</div>

				<button
					type="button"
					class="assignment-btn"
					(click)="goToAssignmentOverview($event, client().id)"
					[disabled]="!!activeNavigation()"
				>
					<span class="text truncate">
						@if (isOpeningAssignmentOverview()) {
							{{ 'client.client_card.field.loading' | transloco }}
						} @else {
							{{ 'client.client_card.field.to_assignment_overview' | transloco }}
						}
					</span>
					<mat-icon class="assignment-btn-icon">arrow_forward</mat-icon>
				</button>
			</div>
		</section>
	} @else {
		<section class="assignments-panel" *lvrPermission="['Assignments.Read', 'Clients.Read.PhaseOneOnly']">
			<!-- Toggle -->
			@if (assignmentsSorted().length > 1) {
				<button
					type="button"
					class="assignments-toggle"
					(click)="toggleAssignments($event)"
					[attr.aria-label]="
						assignmentsExpanded()
							? ('client.client_card.field.collapse_assignments' | transloco)
							: ('client.client_card.field.expand_assignments' | transloco)
					"
					[disabled]="!!activeNavigation()"
				>
					<mat-icon class="material-symbols-outlined" [class.rotated]="assignmentsExpanded()"
						>keyboard_arrow_down</mat-icon
					>
				</button>
			}

			<!-- Main assignment -->
			@if (mainAssignment(); as main) {
				<div class="assignment-block">
					<div class="assignment-info">
						<div>
							<p class="info-line">
								{{ 'client.client_card.field.lastContact' | transloco }}
								{{ main.lastContact }}
							</p>
							<p class="info-line">
								{{ 'client.client_card.field.due_on' | transloco }}
								{{ main.dueDate }}
							</p>
						</div>
					</div>
					<button
						type="button"
						class="assignment-btn"
						[disabled]="!!activeNavigation()"
						(click)="openAssignment($event, main.activeAssignmentId)"
					>
						<span class="text truncate">
							@if (isOpeningAssignment(main.activeAssignmentId)) {
								{{ 'client.client_card.field.loading' | transloco }}
							} @else {
								{{ phaseButtonLabel(main) | transloco }}
								@if (typeOfCareLabel(main)) {
									| {{ typeOfCareLabel(main) | transloco }}
								}
							}
						</span>
						<mat-icon class="assignment-btn-icon">arrow_forward</mat-icon>
					</button>
				</div>
			}

			<!-- Assignments overlay -->
			@if (assignmentsExpanded()) {
				<div class="assignments-overlay">
					@for (a of overlayAssignments(); track a.activeAssignmentId; let last = $last) {
						<div class="assignment-block">
							<div class="assignment-info">
								<div>
									<p class="info-line">
										{{ 'client.client_card.field.lastContact' | transloco }}
										{{ a.lastContact }}
									</p>
									<p class="info-line">
										{{ 'client.client_card.field.due_on' | transloco }}
										{{ a.dueDate }}
									</p>
								</div>
							</div>
							<button
								type="button"
								class="assignment-btn"
								[disabled]="!!activeNavigation()"
								(click)="openAssignment($event, a.activeAssignmentId)"
							>
								<span class="text truncate">
									@if (isOpeningAssignment(a.activeAssignmentId)) {
										{{ 'client.client_card.field.loading' | transloco }}
									} @else {
										{{ typeOfAssignmentLabel(a) | transloco }}
										{{ phaseButtonLabel(a) | transloco }}
										@if (typeOfCareLabel(a)) {
											| {{ typeOfCareLabel(a) | transloco }}
										}
									}
								</span>
								<mat-icon class="assignment-btn-icon">arrow_forward</mat-icon>
							</button>
						</div>
						@if (!last) {
							<hr class="assignment-divider" />
						}
					}
				</div>
			}
		</section>
	}
</mat-card>

@if (assignmentsExpanded()) {
	<div class="overlay-backdrop" (pointerdown)="!activeNavigation() && assignmentsExpanded.set(false)"></div>
}
